import Swiper from "swiper";
import {A11y, FreeMode, Mousewheel, Navigation, Scrollbar} from "swiper/modules";

export function initSeotext(query = document.querySelectorAll('.seotext')) {
    for (let slider of query) {
        const swiperElement = slider.querySelector('.swiper');
        Swiper.use([Navigation,Scrollbar,FreeMode,Mousewheel,A11y]);
        new Swiper(swiperElement, {
            slidesPerView: "auto",
            spaceBetween: 32,
            mode: "horizontal",
            a11y: {
                slideRole: null,
                slideLabelMessage: null
            },
            mousewheel: {
                forceToAxis:true
            },
            freeMode: {
                sticky: true
            },
            scrollbar: {
                el: slider.querySelector('.swiper-scrollbar'),
                draggable: true,
                hide: false,
                snapOnRelease: true,
            },
            navigation: {
                nextEl: slider.querySelector('.swiper-button-next'),
                prevEl: slider.querySelector('.swiper-button-prev'),
            }, breakpoints: {
                0: {
                    slidesPerView: "auto",
                },
                481: {
                    spaceBetween: 24,
                },
                768: {
                    slidesPerView: 4,
                }
            }
        });
    }
}

